/* eslint-disable no-unused-vars */
import React, { Component } from "react";

import _ws from '@netuno/ws-client';

import styles from "./index.less";
import _service from '@netuno/service-client';

import config from "../../config.json";
import Loading from "../Loading/index.jsx";
import Cities from "../Cities/index.jsx";
import Prices from "../Prices/index.jsx";
import Properties from "../Properties/index.jsx";
import Footer from "../Footer/index.jsx";

import Core from '../../Core';

class WorkflowsForms extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadTaskForm: false,
      task: null,
      currentTask: '',
      taskForm: null,
      loadingComplete: false,
      loadingForm: false,
      formData: {},
      uploadFields: [],
      externalCode: null,
      requiredAlert: ["nome"],
      invalidEmail: false,
      phoneIsWhatsapp: true,
      invalidPhone: false,
      invalidWhatsapp: false,
      phoneOrWhatsappOrMailMessage: true,
      isDetailsVisible: false
    };
    this.collapseOnChange = this.collapseOnChange.bind(this);
    this.beforeUpload = this.beforeUpload.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.uploadFile = this.uploadFile.bind(this);
    this.completeTask = this.completeTask.bind(this);
    this.handleSubmitForm = this.handleSubmitForm.bind(this);
    this.icons = ["buy", "rent", "sell", "recruitment", "infos"];
  }

  componentDidMount() {
    const Command = _ws.addListener({
      service: 'remote/command',
      success: (response) => {
        if (JSON.parse(response.content.type).type === "details-is-visible") {
          this.setState({ isDetailsVisible: true })
        } else if (JSON.parse(response.content.type).type === "details-is-no-visible") {
          this.setState({ isDetailsVisible: false })
        }
      },
      fail: (error) => {
        console.error('ws # screen/command', error);
      },
    });
    const { props } = this;

    if (props.externalCode && props.externalCode !== '') {
      //sessionStorage.setItem("externalCode", props.externalCode);
      this.setState({ loadTaskForm: true, externalCode: props.externalCode });
    } else {
      console.log("NO EXTERNAL CODE.");
    }
  }

  componentWillReceiveProps(nextProps) {
    const { props } = this;

    if (props.externalCode !== nextProps.externalCode) {
      this.setState({ loadTaskForm: true, externalCode: nextProps.externalCode });
    }
  }

  componentDidUpdate() {
    const { state } = this;
    if (state.loadTaskForm) {
      this.loadTaskForm();
    }

    if (state.loadingForm) {
      _ws.sendService({
        service: 'ws/remote/command',
        data: {
          type: JSON.stringify({
            type: "loading-on",
            city_uid: "",
            price_min: "",
            price_max: "",
          })
        }
      });
    }
  }

  loadTaskForm() {
    const { props, state } = this;

    if (state.externalCode === '') {
      this.setState({ loadTaskForm: false });
      return;
    }

    this.setState({ loadingForm: true, loadTaskForm: false });
    fetch(`${config.workflowForms.url}/external/forms`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        externalCode: state.externalCode,
        user: props.user,
        token: props.token
      })
    }).then(response => {
      return response.json();
    }).then(json => {
      if (json.error) {
        this.setState({ loadingForm: false });
      } else {
        let taskForm = null;
        let currentTask = '';
        let uploadFields = [];

        json.tasks.forEach(function (task) {
          task.fields.forEach(function (field) {
            if (field.type === 'upload') {
              uploadFields.push({
                taskId: task['executionCodes']['execution_task_code'],
                id: field.id,
                name: field.name,
                file: null
              });
            }
          });

          if (task.key !== "form-end-event") {
            taskForm = task;
            currentTask = task.id;
          }
        });

        if (props.onTaskLoad) {
          props.onTaskLoad(taskForm);
        }

        this.setState({ taskForm, loadingForm: false, uploadFields });
      }
    });
  }

  collapseOnChange(key) {
    const { props, state } = this;
    const { tasks } = state;
    const keyId = key.indexOf('panel-') === 0 ? key.substring('panel-'.length) : '';
    let taskForm = null;
    tasks.forEach((tf) => {
      if (tf.id === keyId) {
        taskForm = tf;
      }
    });
    if (props.onTaskLoad) {
      props.onTaskLoad(taskForm);
    }
    this.setState({ currentTask: keyId, taskForm });
  }

  handleInputChange = (e) => {
    const { formData } = this.state;
    if (e.target.name === "telemovel" || e.target.name === "whatsapp") {
      if (!/^[0-9.]+$/.test(e.target.value) && e.target.value !== "") {
        return
      }

      if ((!/[0-9]{9}$/.test(e.target.value) && e.target.name === "telemovel") && e.target.value !== "") {
        this.setState({ invalidPhone: true })
      } else if (e.target.name === "telemovel") {
        this.setState({ invalidPhone: false })
      }

      if ((!/[0-9]{9}$/.test(e.target.value) && e.target.name === "whatsapp") || (this.state.phoneIsWhatsapp && (!/[0-9]{9}$/.test(e.target.value) && e.target.name === "telemovel") && e.target.value !== "")) {
        this.setState({ invalidWhatsapp: true })
      } else if (e.target.name === "whatsapp" || (e.target.name === "telemovel" && this.state.phoneIsWhatsapp)) {
        this.setState({ invalidWhatsapp: false })
      }

      if (e.target.name === "whatsapp" && e.target.value === "") {
        this.setState({ invalidWhatsapp: false })
      }

      if (e.target.name === "whatsapp") this.setState({ phoneIsWhatsapp: false })
    }
    if (e.target.value.trim() === "" && e.target.name !== "whatsapp" && e.target.name !== "email") this.setState({ requiredAlert: [...this.state.requiredAlert, e.target.name] })
    else this.setState({ requiredAlert: this.state.requiredAlert.filter(field => field !== e.target.name) })

    if (e.target.name === "email" && e.target.value.trim() !== "" && !/\S+@\S+\.\S+/.test(e.target.value)) this.setState({ invalidEmail: true })
    else this.setState({ invalidEmail: false })

    formData[e.target.name] = e.target.value;
    if (this.state.phoneIsWhatsapp && e.target.name === "telemovel") formData["whatsapp"] = e.target.value
    this.setState({ formData });

    if (
      (e.target.name === "email" && (this.state.formData.telemovel === "" || !this.state.formData.telemovel) && (this.state.formData.whatsapp === "" || !this.state.formData.whatsapp) && e.target.value === "") ||
      (e.target.name === "telemovel" && (this.state.formData.email === "" || !this.state.formData.email) && (this.state.formData.whatsapp === "" || !this.state.formData.whatsapp) && e.target.value === "") ||
      (e.target.name === "telemovel" && (this.state.formData.email === "" || !this.state.formData.email) && (this.state.phoneIsWhatsapp) && e.target.value === "") ||
      (e.target.name === "whatsapp" && (this.state.formData.email === "" || !this.state.formData.email) && (this.state.formData.telemovel === "" || !this.state.formData.telemovel) && e.target.value === "")) {
      this.setState({
        phoneOrWhatsappOrMailMessage: true
      })
    } else if (e.target.name === "email" || e.target.name === "telemovel" || e.target.name === "whatsapp") {
      this.setState({
        phoneOrWhatsappOrMailMessage: false
      })
    }
  }

  handleBlurDecimal = (e) => {
    const { formData } = this.state;
    const value = parseFloat(e.target.value);


    formData[e.target.name] = value.toFixed(2);
    this.setState({ formData });
  }

  beforeUpload(a) {
    return false;
  }

  handleMenuClick = async (outcome) => {
    const { formData } = this.state;

    const saveOutcome = await this.setSubmitOutcome(outcome);

    if (saveOutcome) {
      this.completeTask(formData);
    }
  }

  setSubmitOutcome = (outcome) => {
    const { taskForm } = this.state;

    this.setState({ outcome });

    if (taskForm.key === "remontraPrincipal__menu") {
      this.addFormDataItem("remontraPrincipal__menu", outcome);
    }

    return true;
  }

  handleSubmit(e) {
    const { state } = this;
    const { formData } = state;
    e.preventDefault();

    this.completeTask(formData);
  }

  handleSubmitForm(e) {
    const { taskForm } = this.state;
    this.setState({ loading: true });
    if (taskForm.key === "remontroContacto__form") {
      Core.getContext({
        onSuccess: () => {
          const metadata = Core.data().metadata;
          let typeCode = '';
          if (metadata.remontraPrincipal__menu === 'Vender') {
            typeCode = 'sell';
          } else if (metadata.remontraPrincipal__menu === 'Recrutamento') {
            typeCode = 'recruitment';
          }
          const { nome, telemovel, whatsapp, email } = this.state.formData;
          const fields = { nome, telemovel, whatsapp, email }
          const empityFields = []
          let submit = true

          Object.keys(fields).forEach(field => {
            if (!fields[field] && field !== "whatsapp" && field !== "email" && field !== "telemovel") {
              fields[field] = ""
              empityFields.push(field)
            } else if (fields[field]?.trim() === "" && field !== "whatsapp" && field !== "email" && field !== "telemovel") {
              empityFields.push(field)
            }
          })

          if (empityFields.length !== 0) {
            this.setState({ requiredAlert: empityFields })
            submit = false
          }

          if ((telemovel?.trim() === "" && email?.trim() === "" && whatsapp?.trim() === "") ||
            (!telemovel && !email && !whatsapp)) {
            this.setState({
              phoneOrWhatsappOrMailMessage: true
            })
            submit = false
          } else {
            this.setState({
              phoneOrWhatsappOrMailMessage: false
            })
          }

          if (email?.trim() !== "" && email !== undefined) {
            if (!/\S+@\S+\.\S+/.test(email)) {
              this.setState({ invalidEmail: true })
              submit = false
            }
            else this.setState({ invalidEmail: false })
          }

          if (!submit || this.state.invalidPhone || this.state.invalidWhatsapp) return

          _service({
            method: 'POST',
            url: "/remote/contact",
            data: {
              name: nome,
              phone: telemovel,
              whatsapp,
              email,
              session_uid: this.props.data ? this.props.data.uid : '',
              type: typeCode
            },
            success: (response) => {
              if (response.json) {
                this.setState({ loading: false, submitted: true });
                this.completeTask(this.state.formData);
                Core.notification({
                  title: 'OBRIGADO',
                  type: 'success',
                  message: `O seu pedido de contacto para ${typeCode === "sell" ? "venda" : "recrutamento"} foi devidamente registado e comunicaremos de volta muito em breve!`
                });
                this.setState({ phoneIsWhatsapp: true, requiredAlert: ["nome"], phoneOrWhatsappOrMailMessage: true })
              }
            },
            fail: (e) => {
              console.error("Service /remote/contact failed.", e);
              this.setState({ loading: false, error: true });
              Core.notification({
                title: 'Contacto',
                type: 'success',
                message: 'Não foi possível submeter os dados.'
              });
            }
          });
        },
        onFail: (data) => {
          console.log("Context data failed.", data);
          this.setState({ loading: false, error: true });
          Core.notification({
            title: 'Contacto',
            type: 'success',
            message: 'Não foi possível submeter os dados.'
          });
        }
      });
    } else {
      this.completeTask(this.state.formData);
    }
  }

  addFormDataItem = (key, value) => {
    const { formData } = this.state;

    console.log("addFormDataItem");

    formData[key] = value;
    this.setState({ formData });
    console.log("addFormDataItem - END");

    return true;
  }

  handleNext = () => {
    this.setState({ loadingForm: true });
    this.handleMenuClick('next');
  }

  async completeTask(values = {}) {
    const { props, state } = this;
    const { taskForm, uploadFields, outcome } = state;

    if (uploadFields.length > 0) {
      for (const field of uploadFields) {
        if (state.taskForm.executionCodes.execution_task_code === field['taskId']) {
          field['file'] = values[field.id].file;

          const filePath = await this.uploadFile(field);
          values[field.id] = filePath;
        }
      }
    }

    this.setState({ loadingComplete: true });
    const variables = [];

    Object.keys(values).forEach((item) => {
      variables.push({
        key: item,
        value: values[item]
      });
    });

    const fail = (data) => {
      console.log(`Ocorreu um erro ao tentar completar a tarefa ${taskForm.name}.`);
      this.setState({ loadingComplete: false });
    };

    fetch(`${config.workflowForms.url}/task/complete`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        executionCode: state.taskForm.executionCodes.execution_code,
        executionTaskCode: state.taskForm.executionCodes.execution_task_code,
        token: props.token,
        userCode: props.userCode ? props.userCode : "",
        metadata: variables,
        outcome: outcome ? outcome : null,
        formKey: state.taskForm.key ? state.taskForm.key : null
      })
    }).then((response) => {
      if (response.ok) {
        this.setState({ loadingComplete: false, formData: {} });
        const { taskForm } = this.state;
        //alert(`A tarefa ${taskForm.name} foi completada com sucesso.`);

        if (props.onTaskComplete) {
          props.onTaskComplete(taskForm);
        }
        this.loadTaskForm();
        // this.props.onSaved();
      } else {
        fail(response);
      }
    }).catch((error) => {
      fail(error);
    });

    console.log("completeTask: ");
    console.log(taskForm);

    /**if (taskForm.key == "remontroContacto__form") {
      this.listenerSetContact = _ws.addListener({
        service: 'remote/contact',
        success: (res) => {
          console.log('remote/contact');
          console.log(res.content)
        },
        fail: (error) => {
          console.log(error)
        }
      });

      _ws.sendService({
        service: 'remote/contact',
        data: {
          ...values
        }
      });
    }*/
  }

  async uploadFile(field) {
    const { taskForm } = this.state;

    let formData = new FormData();
    formData.append('executionCode', taskForm.executionCodes.execution_code);
    formData.append('executionTaskCode', taskForm.executionCodes.execution_task_code);
    formData.append('executionTaskFileType', field['file']['name'].match(/\.[0-9a-z]+$/i)[0]);
    formData.append('executionTaskFile', field['file']);


    const requestUpload = await fetch(`${config.workflowForms.url}/task/upload`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      body: formData
    });

    const json = await requestUpload.json();

    return json.path;
  }

  static context(externalCode, callback) {
    fetch(`${config.workflowForms.url}/execution/context/get?externalCode=${externalCode}`, {
      method: 'GET',
      credentials: 'include'
    }).then((response) => {
      if (!response.ok) { throw response; }
      return response.json();
    }).then((json) => {
      if (callback && callback.success) {
        callback.success(json);
      }
    }).catch((error) => {
      callback.fail(error);
    });
  }

  render() {
    const { externalCode, onRenderField } = this.props;
    const { loadingForm, loadingComplete, task, currentTask, taskForm, formData } = this.state;

    let formNode = null;
    let controlButtons = false;
    let outcomes = null;

    if (taskForm && taskForm.error !== true) {

      const metadataFields = taskForm.metadata.map(metadata => {
        let fieldInput = null;
        if (metadata.key === "entidades" && metadata.value === "true") {
          fieldInput = (
            <label>
              <input type="text" name={metadata.key} value={formData[`${metadata.key}`]} onChange={this.handleInputChange} />
            </label>
          );
        }
        return fieldInput;
      });

      outcomes = taskForm.outcomes.length > 0 ?
        taskForm.outcomes.map((outcome, index) => {
          return (
            <button onClick={() => { this.handleMenuClick(outcome.name); }} className="outcome">{outcome.name}</button>
          );
        }) : null;

      if (taskForm.key.endsWith("menu") && !this.state.loadingForm) {
        _ws.sendService({
          service: 'ws/remote/command',
          data: {
            type: JSON.stringify({
              type: "home",
              city_uid: "",
              price_min: "",
              price_max: "",
            })
          }
        });

        const options = taskForm.outcomes.map((outcome, index) => {
          return (
            <button key={outcome.name + "-" + index} onClick={() => { this.handleMenuClick(outcome.name); this.setState({ loadingForm: true }); }}>
              {outcome.name}
              <img src={`./icons/${this.icons[index]}.png`} alt={outcome.name} />
            </button>
          );
        });
        outcomes = null;

        formNode = (
          <div className="btn-group">{options}</div>
        );

        if (!taskForm.key.endsWith("Principal__menu")) {
          controlButtons = true;
        }


      } else if (taskForm.key.endsWith("custom")) {
        controlButtons = true;

        formNode = (
          <></>
        );

        if (taskForm.key.startsWith("remontraOndeProcura")) {
          formNode = <Cities
            addMetadata={this.addFormDataItem}
            handleSubmit={this.handleNext}
          />;
        } else if (taskForm.key.startsWith("remontraQueValor")) {
          formNode = <Prices
            addMetadata={this.addFormDataItem}
            handleSubmit={this.handleNext}
          />;
        }
        else if (taskForm.key.startsWith("remontraQueImovel__custom")) {
          formNode = <Properties
            externalCode={externalCode}
            addMetadata={this.addFormDataItem}
            isDetailsVisible={this.state.isDetailsVisible}
          />;
        }
      } else {
        if (taskForm.key.startsWith("remontroContacto__form") && !this.state.loadingForm) {
          _ws.sendService({
            service: 'ws/remote/command',
            data: {
              type: JSON.stringify({
                type: "recruitment-sell",
                city_uid: "",
                price_min: "",
                price_max: "",
              })
            }
          });
        }
        const fields = taskForm.fields.map((field, index) => {
          let fieldInput = null;
          if (onRenderField) {
            //fieldInput = onRenderField({ field, fieldDecorator: getFieldDecorator, taskForm, index });
          }
          if (fieldInput == null) {

            if (field.type === "text") {
              fieldInput = (
                <>
                  <input maxLength={field.id === "whatsapp" ? 15 : 130} type="text" name={field.id} value={formData[`${field.id}`]} onChange={this.handleInputChange} />
                  {this.state.requiredAlert.indexOf(field.id) !== -1 ? <span className="alert">Campo obrigatório.</span> : null}
                  {this.state.invalidEmail && field.id === "email" && this.state.requiredAlert.indexOf("email") === -1 ? <span className="alert">Digite um e-mail válido.</span> : null}
                  {this.state.invalidWhatsapp && field.id === "whatsapp" ? <span className="alert">WhatsApp inválido.</span> : null}
                  {this.state.phoneOrWhatsappOrMailMessage && field.id === "email" ? <span className="alert">Preencha o e-mail, o telefone ou o whatsapp</span> : null}
                  {this.state.phoneOrWhatsappOrMailMessage && field.id === "whatsapp" ? <span className="alert">Preencha o whatsapp, o telefone ou o e-mail</span> : null}
                </>
              );
            } else if (field.type === "multi-line-text") {
              fieldInput = (
                <textarea form={taskForm.id} name={field.id} cols="35" wrap="soft"></textarea>
              );
            } else if (field.type === "integer") {
              fieldInput = (
                <>
                  <input maxLength={15} type="text" name={field.id} value={formData[`${field.id}`]} onChange={this.handleInputChange} />
                  {this.state.phoneOrWhatsappOrMailMessage && field.id === "telemovel" ? <span className="alert">Preencha o telefone, o whatsapp ou o e-mail</span> : null}
                  {this.state.invalidPhone && field.id === "telemovel" && <span className="alert">Telefone inválido.</span>}
                </>
              );
            } else if (field.type === "decimal") {
              fieldInput = (
                <input type="number" name={field.id} value={formData[`${field.id}`]} onChange={this.handleInputChange} onBlur={this.handleBlurDecimal} />
              );
            } else if (field.type === "headline" || field.type === "headline-with-line") {
              fieldInput = (
                <h2 id={field.id}>{field.name}</h2>
              );

              field.name = null;
            } else {
              fieldInput = (
                <p id={field.id}>{field.name}</p>
              );

              field.name = null;
            }
          }
          const fieldIndex = index;

          if (field.name === "Telemovel") {
            field.name = "Telemóvel"
          } else if (field.name === "Email")
            field.name = "E-mail"
          return (
            <label>
              {field.name}
              {fieldInput}
            </label>
          );
        });

        formNode = (
          <>
            <form onSubmit={this.handleSubmit}>
              {metadataFields}
              {fields}
              <button type="button" className="submit-btn" onClick={this.handleSubmitForm}>Enviar</button>
              {loadingComplete ?
                <Loading />
                :
                <div>
                  <div className="btn-controls" style={{ width: taskForm.key === "remontroContacto__form" ? "100%" : "0" }}>
                    {!this.state.isDetailsVisible ? (
                      <button onClick={() => { this.handleMenuClick("back"); this.setState({ loadingForm: true }); }}>
                        <img src="./icons/arrow-left.svg" alt="Voltar" />
                      </button>
                    ) : null}
                    {taskForm.key !== "remontroContacto__form" && (
                      <Footer width={taskForm.key === "remontraPrincipal__menu" || this.state.isDetailsVisible ? "100%" : "50%"} data={this.props.data} />
                    )}
                  </div>
                </div>
              }
            </form>
          </>
        );
      }

    } else if (externalCode !== '' && (taskForm && taskForm.error === true)) {
      formNode = <div>Erro ao carregar o formulário...</div>;
    }

    return (
      loadingForm ?
        <div className={styles.loading}>
          <Loading />
        </div> :
        <div className="container">
          {!taskForm ?
            <div>Nenhuma tarefa foi encontrada.</div>
            :
            (
              <>
                <div className="title">
                  {controlButtons && !this.state.isDetailsVisible ?
                    (
                      <div className="btn-controls">
                        <button onClick={() => { this.handleMenuClick("back"); this.setState({ loadingForm: true }); }}>
                          <img src="./icons/arrow-left.svg" alt="Voltar" />
                        </button>
                      </div>
                    )
                    : null}
                  { /* <h3>{taskForm.executionCodes.execution_task_name}</h3> */}
                </div>
                <div className="content">
                  {formNode}
                  {outcomes}
                  {taskForm.key !== "remontroContacto__form" && (
                    <Footer data={this.props.data} width={taskForm.key === "remontraPrincipal__menu" || this.state.isDetailsVisible ? "100%" : "50%"} />
                  )}
                </div>
              </>
            )
          }
        </div>
    );
  }
}

export default WorkflowsForms;
